import { UseQueryOptions } from '@tanstack/react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';
import type { AccessCentreMeApiResponse } from 'domains/accessCentre/types';

type UseGetMyPermissionsParams = {
    enabled?: boolean;
    reactQueryOptions?: UseQueryOptions<AccessCentreMeApiResponse, Error>;
};

/**
 * GET /me — current user and their permission keys.
 * Use when the user is logged in to drive UI visibility (show/hide features by permission).
 * @see access-centre-api.md § Self (current user)
 */
const useGetMyPermissions = ({ enabled = true, reactQueryOptions }: UseGetMyPermissionsParams = {}) => {
    const queryKey = QueryKeys.ACCESS_CENTRE_ME();
    return useQuery<AccessCentreMeApiResponse>(queryKey, CuredApiPaths.ACCESS_CENTRE_ME, {
        enabled,
        ...reactQueryOptions,
    });
};

export default useGetMyPermissions;
